import React from "react";

const CategoriesBtn = (props) => {
  return (
    <button
      className={`${props.CateclassName} ${
        props.disabled ? "opacity-50 cursor-not-allowed categories-home" : "cursor-pointer categories-home"
      }`}
      style={{ backgroundColor: props.bgColor }}
      onClick={() => (props.onClick ? props.onClick() : null)}
      type="button"
      disabled={props?.disabled}
    >
      <div
        className={`relative flex items-center justify-center ${props.iconlayout}`}
      >
        <img
          className={`w-6 h-6 ${props.btnIconlayout}`}
          src={props.btnIcon}
          alt={props.btnTitle}
        />
      </div>
      {props?.comingSoon && (
        <div className="absolute top-0 right-0 xs:w-16 sm:w-20 rounded-md xs:!py-[1px] sm:py-[1.5px] shadow-[0px_6px_6px_rgba(0,0,0,0.2)] bg-accepted">
          <p
            className={`${props.fontClassname} text-primary xs:!text-[6px] sm:!text-[8px] leading-[10px]`}
          >
            {props.comingSoon}
          </p>
        </div>
      )}
      <div className="relative z-5">
        <p className={`${props.fontClassname} text-secondary`}>
          {props.btnTitle}
        </p>
      </div>
    </button>
  );
};

export default CategoriesBtn;
